import { PACKAGE_TYPE } from '@src/constants/package';

const { useCheckAPIRoute } = require('./useCheckDubbingRoute');

export const useCheckProductName = () => {
  const checkAPI = useCheckAPIRoute();
  if (checkAPI) return PACKAGE_TYPE.API;
  return PACKAGE_TYPE.STUDIO;
};
